export const META_TYPE = 'powerUsage';
export const META_VER = 'v1';

export const CMD_POWERUSAGE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
